// Importing options from base theme
import { createOptions as createBaseOptions } from './base/create-options';
// Importing 3rd party dependencies
import { deDE, enUS } from '@mui/material/locale';
import { createTheme as createMuiTheme, responsiveFontSizes } from '@mui/material/styles';
// ----------------------------------------------------------------------
// Helper function to convert i18n string to MUI locale code
const muiLocale = (locale) => {
    switch (locale) {
        case 'de':
            return deDE;
        case 'en':
            return enUS;
        default:
            return deDE;
    }
};
// ----------------------------------------------------------------------
export const createTheme = (config, locale) => {
    // Creating theme based on options
    let theme = createMuiTheme(createBaseOptions());
    // Adding responsive font sizes
    if (config.responsiveFontSizes) {
        theme = responsiveFontSizes(theme);
    }
    // Adding locale to theme
    const convertedLocale = muiLocale(locale);
    const themeWithLocale = createMuiTheme(theme, convertedLocale);
    // Returning base theme
    return themeWithLocale;
};
